// import styled from "styled-components";
// import {NavLink} from "react-router-dom";

// export const StyledLinkContainer = styled.div`
//   position: relative;
//   cursor: pointer;

//   &:not(:first-child) {
//     margin-top: 0.2rem;
//   }

//   &::before {
//     content: "";
//     position: absolute;
//     height: 100%;
//     width: 5px;
//     background-color: #f5f5f5;
//     transform: scaleY(0);
//     transition: transform 0.1s, width 0.2s cubic-bezier(1, 0, 0, 1) 0.1s;
//   }

//   &:hover::before {
//     transform: scaleY(1);
//     width: 100%;
//     border-radius: 1.2rem;
//   }
// `;

// export const StyledNavLink = styled(NavLink)<{
//   visible?: boolean;
// }>`
//   display: flex;
//   align-items: center;
//   height: 4.8rem;
//   padding: 0 1.7rem;
//   z-index: 10;
//   position: relative;

//   .nav-label {
//     margin-left: 1rem;
//     color: #1c1726;
//     font-weight: 400;
//     font-size: 1.4rem;
//     white-space: nowrap;
//     transition: opacity 0.3s cubic-bezier(0.4, 0, 1, 1);
//   }

//   .nav-icon-container {
//     width: 2rem;
//     height: 2rem;
//     color: #8c8c8c;

//     span {
//       width: 100%;
//       height: 100%;
//       svg {
//         width: 100%;
//         height: 100%;
//       }
//     }
//   }

//   .coming-soon-bubble {
//     background-color: #f0f5ff;
//     border: 1px solid #adc6ff;
//     border-radius: 2px;
//     font-weight: 600;
//     font-size: 1rem;
//     color: #2f54eb;
//     height: 2.2rem;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     padding: 0 8px;
//     margin-left: auto;
//   }

//   &:hover {
//     // background-color: #F5F5F5;
//     color: #222222;

//     .nav-label,
//     .nav-icon-container {
//       font-weight: 600;
//       color: #222222;
//     }
//   }

//   &.active {
//     background-color: #f5f5f5;
//     color: #222222;
//     border-radius: 1.2rem;

//     .nav-label,
//     .nav-icon-container {
//       font-weight: 600;
//       color: #222222;
//     }

//     &::before {
//       content: "";
//       position: absolute;
//       height: 12px;
//       width: 4px;
//       border-radius: 0px 20px 20px 0px;
//       background-color: #222222;
//       left: 0;
//       top: 50%;
//       transform: translateY(-50%);
//     }
//   }

//   @media (max-width: 960px) {
//     .nav-label {
//       opacity: 1;
//     }
//   }
// `;
// export const StyledBtnLink = styled.a<{
//   visible?: boolean;
// }>`
//   display: flex;
//   align-items: center;
//   height: 4.8rem;
//   padding: 0 1.7rem;
//   z-index: 10;
//   position: relative;
//   border: none;

//   .nav-label {
//     margin-left: 1rem;
//     color: #1c1726;
//     font-weight: 400;
//     font-size: 1.4rem;
//     white-space: nowrap;
//     transition: opacity 0.3s cubic-bezier(0.4, 0, 1, 1);
//   }

//   .nav-icon-container {
//     width: 2rem;
//     height: 2rem;
//     color: #8c8c8c;
//     display: flex;

//     span {
//       width: 100%;
//       height: 100%;
//       svg {
//         width: 100%;
//         height: 100%;
//       }
//     }
//   }

//   .coming-soon-bubble {
//     background-color: #f0f5ff;
//     border: 1px solid #adc6ff;
//     border-radius: 2px;
//     font-weight: 600;
//     font-size: 1rem;
//     color: #2f54eb;
//     height: 2.2rem;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     padding: 0 8px;
//     margin-left: auto;
//   }

//   &:hover {
//     color: #222222;

//     .nav-label,
//     .nav-icon-container {
//       font-weight: 600;
//       color: #222222;
//     }
//   }

//   &.active {
//     background-color: #f5f5f5;
//     color: #222222;

//     .nav-label,
//     .nav-icon-container {
//       font-weight: 600;
//       color: #222222;
//     }

//     &::before {
//       content: "";
//       position: absolute;
//       height: 12px;
//       width: 4px;
//       border-radius: 0px 20px 20px 0px;
//       background-color: #222222;
//       left: 0;
//       top: 50%;
//       transform: translateY(-50%);
//     }
//   }

//   @media (max-width: 960px) {
//     .nav-label {
//       opacity: 1;
//     }
//   }
// `;
// export const StyledStaticNavLink = styled.span<{
//   visible?: boolean;
// }>`
//   display: flex;
//   align-items: center;
//   height: 4.8rem;
//   padding: 0 1.7rem;
//   z-index: 10;
//   position: relative;
//   // margin-top: 1rem;

//   .nav-label {
//     margin-left: 1rem;
//     color: #1c1726;
//     font-weight: 400;
//     font-size: 1.4rem;
//     white-space: nowrap;
//     transition: opacity 0.3s cubic-bezier(0.4, 0, 1, 1);
//   }

//   .nav-icon-container {
//     width: 2rem;
//     height: 2rem;
//     color: #8c8c8c;

//     span {
//       width: 100%;
//       height: 100%;
//       svg {
//         width: 100%;
//         height: 100%;
//       }
//     }
//   }

//   .coming-soon-bubble {
//     background-color: #f0f5ff;
//     border: 1px solid #adc6ff;
//     border-radius: 2px;
//     font-weight: 600;
//     font-size: 1rem;
//     color: #2f54eb;
//     height: 2.2rem;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     padding: 0 8px;
//     margin-left: auto;
//   }

//   &:hover {
//     // background-color: #F5F5F5;
//     color: #222222;

//     .nav-label,
//     .nav-icon-container {
//       font-weight: 600;
//       color: #222222;
//     }
//     // &::before {
//     //   content: "";
//     //   position: absolute;
//     //   height: 100%;
//     //   width: 5px;
//     //   background-color: #000000;
//     //   left: 0;
//     //   top: 0;
//     // }
//   }

//   &.active {
//     background-color: #f5f5f5;
//     color: #222222;

//     .nav-label,
//     .nav-icon-container {
//       font-weight: 600;
//       color: #222222;
//     }

//     &::before {
//       content: "";
//       position: absolute;
//       height: 12px;
//       width: 4px;
//       border-radius: 0px 20px 20px 0px;
//       background-color: #222222;
//       left: 0;
//       top: 50%;
//       transform: translateY(-50%);
//     }
//   }

//   @media (max-width: 960px) {
//     .nav-label {
//       opacity: 1;
//     }
//   }
// `;
// export const StyledComingSoon = styled.span<{
//   visible?: boolean;
// }>`
//   display: flex;
//   align-items: center;
//   height: 4.8rem;
//   padding: 0 1.7rem;
//   z-index: 10;
//   position: relative;
//   // margin-top: 1rem;

//   .nav-label {
//     margin-left: 1rem;
//     color: #1c1726;
//     font-weight: 400;
//     font-size: 1.4rem;
//     white-space: nowrap;
//     transition: opacity 0.3s cubic-bezier(0.4, 0, 1, 1);
//   }

//   .nav-icon-container {
//     width: 2rem;
//     height: 2rem;
//     color: #8c8c8c;

//     span {
//       width: 100%;
//       height: 100%;
//       svg {
//         width: 100%;
//         height: 100%;
//       }
//     }
//   }

//   .coming-soon-bubble {
//     background-color: #f0f5ff;
//     border: 1px solid #adc6ff;
//     border-radius: 2px;
//     font-weight: 600;
//     font-size: 1rem;
//     color: #2f54eb;
//     height: 2.2rem;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     padding: 0 8px;
//     margin-left: auto;
//   }

//   &:hover {
//     // background-color: #F5F5F5;
//     color: #222222;

//     .nav-label,
//     .nav-icon-container {
//       font-weight: 600;
//       color: #222222;
//     }
//     // &::before {
//     //   content: "";
//     //   position: absolute;
//     //   height: 100%;
//     //   width: 5px;
//     //   background-color: #000000;
//     //   left: 0;
//     //   top: 0;
//     // }
//   }

//   &.active {
//     background-color: #f5f5f5;
//     color: #222222;

//     .nav-label,
//     .nav-icon-container {
//       font-weight: 600;
//       color: #222222;
//     }

//     &::before {
//       content: "";
//       position: absolute;
//       height: 12px;
//       width: 4px;
//       border-radius: 0px 20px 20px 0px;
//       background-color: #222222;
//       left: 0;
//       top: 50%;
//       transform: translateY(-50%);
//     }
//   }

//   @media (max-width: 960px) {
//     .nav-label {
//       opacity: 1;
//     }
//   }
// `;

// import styled from "styled-components";
// import {NavLink} from "react-router-dom";

// /* Shared tokens */
// const colors = {
//   text: "#222222",
//   textMuted: "#8c8c8c",
//   label: "#1c1726",
//   bgActive: "#f5f5f5",
//   bubbleBg: "#f0f5ff",
//   bubbleBorder: "#adc6ff",
//   bubbleText: "#2f54eb",
// };

// /* 1) Container with anchored background highlight that won't block clicks */
// export const StyledLinkContainer = styled.div`
//   position: relative;
//   cursor: pointer;
//   overflow: hidden; /* keep the expanding bg clipped to the row */

//   &:not(:first-child) {
//     margin-top: 0.2rem;
//   }

//   /* Background highlight bar behind the content */
//   &::before {
//     content: "";
//     position: absolute;
//     inset: 0 0 0 0; /* top:0; right:0; bottom:0; left:0 */
//     background-color: ${colors.bgActive};
//     transform: scaleX(0);
//     transform-origin: left; /* expand from the left edge */
//     transition: transform 0.2s cubic-bezier(0.4, 0, 1, 1);
//     border-radius: 1.2rem;
//     pointer-events: none; /* never steal clicks */
//     z-index: 0; /* sit under the link content */
//   }

//   &:hover::before {
//     transform: scaleX(1);
//   }
// `;

// /* Transient prop ($visible) won't be forwarded to the DOM */
// export const StyledNavLink = styled(NavLink)<{$visible?: boolean}>`
//   display: flex;
//   align-items: center;
//   height: 4.8rem;
//   padding: 0 1.7rem;
//   z-index: 1; /* above the ::before background */
//   position: relative;
//   text-decoration: none;
//   outline: none;

//   /* Label */
//   .nav-label {
//     margin-left: 1rem;
//     color: ${colors.label};
//     font-weight: 400;
//     font-size: 1.4rem;
//     white-space: nowrap;
//     transition: opacity 0.3s cubic-bezier(0.4, 0, 1, 1), color 0.2s ease,
//       font-weight 0.2s ease;
//   }

//   /* Icon wrapper */
//   .nav-icon-container {
//     width: 2rem;
//     height: 2rem;
//     color: ${colors.textMuted};
//     display: inline-flex;

//     span {
//       width: 100%;
//       height: 100%;
//       display: inline-flex;

//       svg {
//         width: 100%;
//         height: 100%;
//       }
//     }
//   }

//   /* "Coming soon" chip */
//   .coming-soon-bubble {
//     background-color: ${colors.bubbleBg};
//     border: 1px solid ${colors.bubbleBorder};
//     border-radius: 2px;
//     font-weight: 600;
//     font-size: 1rem;
//     color: ${colors.bubbleText};
//     height: 2.2rem;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     padding: 0 8px;
//     margin-left: auto;
//   }

//   /* Hover */
//   &:hover {
//     background-color: ${colors.bgActive};
//     color: ${colors.text};
//     border-radius: 1.2rem;

//     .nav-label,
//     .nav-icon-container {
//       font-weight: 600;
//       color: ${colors.text};
//     }
//   }

//   /* Keyboard focus */
//   &:focus-visible {
//     outline: 2px solid ${colors.text};
//     outline-offset: 2px;
//     border-radius: 1.2rem;
//   }

//   /* Active (NavLink auto-applies "active" when matched) */
//   &.active {
//     background-color: ${colors.bgActive};
//     color: ${colors.text};
//     border-radius: 1.2rem;

//     .nav-label,
//     .nav-icon-container {
//       font-weight: 600;
//       color: ${colors.text};
//     }

//     &::after {
//       content: "";
//       position: absolute;
//       left: 0;
//       top: 50%;
//       transform: translateY(-50%);
//       height: 12px;
//       width: 4px;
//       border-radius: 0 20px 20px 0;
//       background-color: ${colors.text};
//     }
//   }

//   @media (max-width: 960px) {
//     .nav-label {
//       opacity: 1;
//     }
//   }
// `;

// /* Button-like link (anchor). Uses the same visual language as StyledNavLink. */
// export const StyledBtnLink = styled.a<{
//   $visible?: boolean;
// }>`
//   display: flex;
//   align-items: center;
//   height: 4.8rem;
//   padding: 0 1.7rem;
//   z-index: 1;
//   position: relative;
//   text-decoration: none;
//   outline: none;
//   border: none;
//   background: transparent;

//   .nav-label {
//     margin-left: 1rem;
//     color: ${colors.label};
//     font-weight: 400;
//     font-size: 1.4rem;
//     white-space: nowrap;
//     transition: opacity 0.3s cubic-bezier(0.4, 0, 1, 1), color 0.2s ease;
//   }

//   .nav-icon-container {
//     width: 2rem;
//     height: 2rem;
//     color: ${colors.textMuted};
//     display: inline-flex;

//     span {
//       width: 100%;
//       height: 100%;
//       display: inline-flex;

//       svg {
//         width: 100%;
//         height: 100%;
//       }
//     }
//   }

//   .coming-soon-bubble {
//     background-color: ${colors.bubbleBg};
//     border: 1px solid ${colors.bubbleBorder};
//     border-radius: 2px;
//     font-weight: 600;
//     font-size: 1rem;
//     color: ${colors.bubbleText};
//     height: 2.2rem;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     padding: 0 8px;
//     margin-left: auto;
//   }

//   &:hover {
//     color: ${colors.text};

//     .nav-label,
//     .nav-icon-container {
//       color: ${colors.text};
//     }
//   }

//   &:focus-visible {
//     outline: 2px solid ${colors.text};
//     outline-offset: 2px;
//     border-radius: 1rem;
//   }

//   @media (max-width: 960px) {
//     .nav-label {
//       opacity: 1;
//     }
//   }
// `;

// /* Non-interactive static item (use <a> or <button> if it should be clickable) */
// export const StyledStaticNavLink = styled.span<{
//   $visible?: boolean;
// }>`
//   display: flex;
//   align-items: center;
//   height: 4.8rem;
//   padding: 0 1.7rem;
//   z-index: 1;
//   position: relative;

//   .nav-label {
//     margin-left: 1rem;
//     color: ${colors.label};
//     font-weight: 400;
//     font-size: 1.4rem;
//     white-space: nowrap;
//     transition: opacity 0.3s cubic-bezier(0.4, 0, 1, 1);
//   }

//   .nav-icon-container {
//     width: 2rem;
//     height: 2rem;
//     color: ${colors.textMuted};

//     span {
//       width: 100%;
//       height: 100%;

//       svg {
//         width: 100%;
//         height: 100%;
//       }
//     }
//   }

//   .coming-soon-bubble {
//     background-color: ${colors.bubbleBg};
//     border: 1px solid ${colors.bubbleBorder};
//     border-radius: 2px;
//     font-weight: 600;
//     font-size: 1rem;
//     color: ${colors.bubbleText};
//     height: 2.2rem;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     padding: 0 8px;
//     margin-left: auto;
//   }

//   @media (max-width: 960px) {
//     .nav-label {
//       opacity: 1;
//     }
//   }
// `;

// /* Decorative, non-interactive "Coming Soon" row */
// export const StyledComingSoon = styled.span<{
//   $visible?: boolean;
// }>`
//   display: flex;
//   align-items: center;
//   height: 4.8rem;
//   padding: 0 1.7rem;
//   z-index: 1;
//   position: relative;

//   .nav-label {
//     margin-left: 1rem;
//     color: ${colors.label};
//     font-weight: 400;
//     font-size: 1.4rem;
//     white-space: nowrap;
//     transition: opacity 0.3s cubic-bezier(0.4, 0, 1, 1);
//   }

//   .nav-icon-container {
//     width: 2rem;
//     height: 2rem;
//     color: ${colors.textMuted};

//     span {
//       width: 100%;
//       height: 100%;

//       svg {
//         width: 100%;
//         height: 100%;
//       }
//     }
//   }

//   .coming-soon-bubble {
//     background-color: ${colors.bubbleBg};
//     border: 1px solid ${colors.bubbleBorder};
//     border-radius: 2px;
//     font-weight: 600;
//     font-size: 1rem;
//     color: ${colors.bubbleText};
//     height: 2.2rem;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     padding: 0 8px;
//     margin-left: auto;
//   }

//   @media (max-width: 960px) {
//     .nav-label {
//       opacity: 1;
//     }
//   }
// `;

import styled from "styled-components";
import {Link, NavLink} from "react-router-dom";

/* Shared tokens */
const colors = {
  text: "#222222",
  textMuted: "#8c8c8c",
  label: "#1c1726",
  bgActive: "#f5f5f5",
  bubbleBg: "#f0f5ff",
  bubbleBorder: "#adc6ff",
  bubbleText: "#2f54eb",
  divider: "#e9e9e9",
};

/* Container for each nav group (one parent row + optional submenu) */
export const StyledLinkContainer = styled.div`
  position: relative;

  &:not(:first-child) {
    margin-top: 0.2rem;
  }

  /* The clickable row (parent) */
  .row {
    position: relative;
    display: flex;
    align-items: center;
    height: 4.8rem;
    border-radius: 1.2rem;
    /* Background highlight behind the content */
    &::before {
      content: "";
      position: absolute;
      inset: 0;
      background-color: ${colors.bgActive};
      transform: scaleX(0);
      transform-origin: left;
      transition: transform 0.2s cubic-bezier(0.4, 0, 1, 1);
      border-radius: 1.2rem;
      pointer-events: none;
      z-index: 0;
    }
  }

  /* Hover state -> reveal the chip-like bg on the row */
  .row:hover::before {
    transform: scaleX(1);
  }
`;

/* Transient prop ($visible) won't be forwarded to DOM */
export const StyledNavLink = styled(NavLink)<{$visible?: boolean}>`
  display: flex;
  align-items: center;
  height: 4.8rem;
  padding: 0 1.7rem;
  position: relative;
  z-index: 1; /* above the row ::before */
  text-decoration: none;
  outline: none;
  flex: 1 1 auto; /* take available space so chevron can sit at end */

  .nav-label {
    margin-left: 1rem;
    color: ${colors.label};
    font-weight: 400;
    font-size: 12px;
    white-space: nowrap;
    transition: opacity 0.3s cubic-bezier(0.4, 0, 1, 1), color 0.2s ease,
      font-weight 0.2s ease;
  }

  .nav-icon-container {
    width: 16px;
    height: 16px;
    color: ${colors.textMuted};
    display: inline-flex;

    span {
      width: 100%;
      height: 100%;
      display: inline-flex;

      svg {
        width: 100%;
        height: 100%;
      }
    }
  }

  .coming-soon-bubble {
    background-color: ${colors.bubbleBg};
    border: 1px solid ${colors.bubbleBorder};
    border-radius: 2px;
    font-weight: 600;
    font-size: 1rem;
    color: ${colors.bubbleText};
    height: 2.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 8px;
    margin-left: auto;
  }

  /* Hover */
  &:hover {
    background-color: ${colors.bgActive};
    color: ${colors.text};
    border-radius: 1.2rem;

    .nav-label,
    .nav-icon-container {
      font-weight: 600;
      color: ${colors.text};
    }
  }

  /* Keyboard focus */
  &:focus-visible {
    outline: 2px solid ${colors.text};
    outline-offset: 2px;
    border-radius: 1.2rem;
  }

  /* Active (NavLink auto-applies "active") */
  &.active {
    background-color: ${colors.bgActive};
    color: ${colors.text};
    border-radius: 1.2rem;

    .nav-label,
    .nav-icon-container {
      font-weight: 600;
      color: ${colors.text};
    }

    &::after {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      height: 12px;
      width: 4px;
      border-radius: 0 20px 20px 0;
      background-color: ${colors.text};
    }
  }

  @media (max-width: 960px) {
    .nav-label {
      opacity: 1;
    }
  }
`;

/* Button that only toggles the submenu */
export const StyledChevronButton = styled.button`
  position: relative;
  z-index: 1; /* above the row ::before */
  appearance: none;
  border: 0;
  background: transparent;
  cursor: pointer;
  height: 4.8rem;
  padding: 0 1.2rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${colors.textMuted};
  border-radius: 1.2rem;

  &:hover {
    color: ${colors.text};
    /* subtle bg hover to enlarge hit area */
    background: ${colors.bgActive};
  }

  &:focus-visible {
    outline: 2px solid ${colors.text};
    outline-offset: 2px;
  }
`;

/* Submenu wrapper with height animation */
export const StyledSubmenu = styled.ul<{$open?: boolean}>`
  list-style: none;
  margin: 0.4rem 0 0 0;
  padding: 0 0 0 3.6rem; /* indent to align under label */
  position: relative;

  /* dotted guide on the left (approx to your screenshot) */
  &::before {
    content: "";
    position: absolute;
    left: 1.9rem; /* aligns under the icon center */
    top: 0.4rem;
    bottom: 0.4rem;
    border-left: 3px dashed ${colors.divider};
  }

  max-height: ${({$open}) => ($open ? "600px" : "0px")};
  opacity: ${({$open}) => ($open ? 1 : 0)};
  overflow: hidden;
  transition: max-height 220ms ease, opacity 220ms ease;
`;

/* Each submenu item is a NavLink with lighter height */
export const StyledSubmenuItem = styled(Link)`
  display: flex;
  align-items: center;
  height: 4.6rem;
  line-height: 4.6rem;
  padding: 1.2rem 1.6rem;
  /* margin: 0.2rem 0; */
  text-decoration: none;
  color: ${colors.text};
  border-radius: 8px;
  position: relative;

  &:hover {
    background: ${colors.bgActive};
    font-weight: 600;
  }

  &.active {
    background: ${colors.bgActive};
    font-weight: 600;
  }
`;

/* Button-like and static items left as-is from your version */
export const StyledBtnLink = styled.a<{$visible?: boolean}>`
  display: flex;
  align-items: center;
  height: 4.8rem;
  padding: 0 1.7rem;
  z-index: 1;
  position: relative;
  text-decoration: none;
  outline: none;
  border: none;
  background: transparent;

  .nav-label {
    margin-left: 1rem;
    color: ${colors.label};
    font-weight: 400;
    font-size: 12px;
    white-space: nowrap;
    transition: opacity 0.3s cubic-bezier(0.4, 0, 1, 1), color 0.2s ease;
  }

  .nav-icon-container {
    width: 16px;
    height: 16px;
    color: ${colors.textMuted};
    display: inline-flex;

    span {
      width: 100%;
      height: 100%;
      display: inline-flex;

      svg {
        width: 100%;
        height: 100%;
      }
    }
  }

  .coming-soon-bubble {
    background-color: ${colors.bubbleBg};
    border: 1px solid ${colors.bubbleBorder};
    border-radius: 2px;
    font-weight: 600;
    font-size: 1rem;
    color: ${colors.bubbleText};
    height: 2.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 8px;
    margin-left: auto;
  }

  &:hover {
    color: ${colors.text};

    .nav-label,
    .nav-icon-container {
      color: ${colors.text};
    }
  }

  &:focus-visible {
    outline: 2px solid ${colors.text};
    outline-offset: 2px;
    border-radius: 1rem;
  }

  @media (max-width: 960px) {
    .nav-label {
      opacity: 1;
    }
  }
`;

export const StyledStaticNavLink = styled.span<{$visible?: boolean}>`
  display: flex;
  align-items: center;
  height: 4.8rem;
  padding: 0 1.7rem;
  z-index: 1;
  position: relative;

  .nav-label {
    margin-left: 1rem;
    color: ${colors.label};
    font-weight: 400;
    font-size: 1.4rem;
    white-space: nowrap;
    transition: opacity 0.3s cubic-bezier(0.4, 0, 1, 1);
  }

  .nav-icon-container {
    width: 2rem;
    height: 2rem;
    color: ${colors.textMuted};

    span {
      width: 100%;
      height: 100%;

      svg {
        width: 100%;
        height: 100%;
      }
    }
  }

  .coming-soon-bubble {
    background-color: ${colors.bubbleBg};
    border: 1px solid ${colors.bubbleBorder};
    border-radius: 2px;
    font-weight: 600;
    font-size: 1rem;
    color: ${colors.bubbleText};
    height: 2.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 8px;
    margin-left: auto;
  }

  @media (max-width: 960px) {
    .nav-label {
      opacity: 1;
    }
  }
`;
